import styled from 'styled-components';

export const TransactionWrapper = styled.div`
  .transaction-dropdown {
    .dropdown {
      border-radius: 4px;
      border: 1px solid #ebeaed;
      display: flex;
      background: #fff;
      align-items: center;
      height: 48px !important;
      .nav-link {
        /* height: 100%; */
      }
    }
  }
  .transaction-expand {
    td {
      border-top: 1px dashed #84818a;
    }
    tr:first-child {
      td {
        border-top: none;
      }
    }
  }
  .rdt_Table {
    background-color: transparent;
    border-bottom: none;
  }
  .rdt_TableHeadRow {
    background: #f8f8f8;
    border-bottom: none;
  }
  .rdt_TableHeadRow > div:first-child {
    padding-left: 10px !important;
    display: none;
  }
  .rdt_TableRow > div:first-child {
    padding-left: 10px !important;
    display: none;
  }
  .rdt_TableRow {
    margin-bottom: 16px;
    border-bottom: none;
    border-radius: 4px;
    box-shadow: 1px 4px 4px #88888217;
  }
  .rdt_ExpanderRow {
    background: #efefef;
    margin-top: -16px;
    padding-top: 10px;
    .table th,
    .table td {
      padding: 5px 10px;
    }
    thead {
      th {
        background-color: #efefef !important;
        font-weight: normal;
      }
    }
    tbody {
      tr {
        font-size: 14px;
      }
    }
  }
`;
